import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.dizest.sidebar.timer');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Input } from '@angular/core';

@Component({
    selector: 'wiz-portal-dizest-sidebar-timer',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.dizest.sidebar.timer/view.scss */
.workspace-tab {
  height: 100%;
  width: 50vw;
  max-width: 520px;
  min-width: 320px;
  display: flex;
  flex-direction: column;
  background: #fff;
  background: var(--wc-background);
  border-left: 1px solid var(--wc-border);
}
.workspace-tab .workspace-tab-header {
  display: flex;
  background: var(--wc-blue);
  padding: 4px 12px;
  height: 40px;
  align-items: center;
}
.workspace-tab .workspace-tab-header .workspace-tab-header-title {
  color: white;
  font-family: "wiz-eb";
  font-size: 16px;
}
.workspace-tab .workspace-tab-header .close-btn {
  font-size: 16px;
  cursor: pointer;
}
.workspace-tab .workspace-tab-body-wrapper {
  position: relative;
  overflow: hidden;
  width: 100%;
  flex: 1;
}
.workspace-tab .workspace-tab-body {
  padding: 16px;
  height: 100%;
  width: 100%;
  position: absolute;
  overflow: auto;
  padding-bottom: 40vh;
}

.featured-image {
  max-width: 100%;
  max-height: 280px;
}

.nowrap {
  white-space: nowrap;
}

.card-table {
  border-bottom: none;
}
.card-table td, .card-table th {
  padding: 8px 12px;
}`],
})
export class PortalDizestSidebarTimerComponent implements OnInit, OnDestroy {
    @Input() sidebar: any = null;

    constructor(@Inject( Service    )         public service: Service    ) { }

    public async ngOnInit() {
        await this.refresh();
    }

    public async ngOnDestroy() {
    }

    public specs: any = [];
    public list: any = [];
    public query: any = { time: '0 2 * * *', spec: 'base', comment: '' };

    public async request(fnname: string, query: any = {}) {
        let dizest = this.sidebar.selected.dizest;
        query.workflow_id = this.sidebar.selected.workflow.id;
        const { code, data } = await dizest.api.call('timer', fnname, query);
        return { code, data };
    }

    public async refresh() {
        let workflow = this.sidebar.selected.workflow;
        const { data } = await this.request("list");
        this.list = data;
        this.query.spec = (await workflow.spec()).name;
        this.specs = await workflow.dizest.specs();
        await this.service.render();
    }

    public async remove(comment) {
        await this.request("remove", { comment: comment });
        await this.refresh();
    }

    public async add() {
        await this.request("add", this.query);
        this.query = { time: '0 2 * * *', spec: this.query.spec };
        await this.refresh();
    }

    public async close() {
        await this.sidebar.close();
    }
}

export default PortalDizestSidebarTimerComponent;